module.exports = {
	"library.footer.terms_of_use": "användarvillkor",
	"library.footer.terms_and_conditions": "Regler och villkor",
	"library.footer.privacy_policy": "Integritetspolicy",
	"library.footer.get_to_know_us": "Lär känna oss",
	"library.footer.about": "Om",
	"library.footer.jobs": "Jobb",
	"library.footer.blog": "Blogg",
	"library.footer.get_help": "Få hjälp",
	"library.footer.find_events": "Hitta evenemang",
	"library.footer.top_events": "Populära evenemang",
	"library.footer.host_events": "Arrangera evenemang",
	"library.footer.become_a_host": "Bli arrangör",
	"library.footer.tour": "Rundtur",
	"library.footer.embeddable_widgets": "Widgets som kan bäddas in",
	"library.footer.customers": "Kunder",
	"library.footer.pricing": "Priser",
	"library.footer.get_the_onsite_app": "Skaffa evenemangsappen",
	"library.footer.developers": "Utvecklare",
	"library.footer.contact_us": "Kontakta oss"
};


//////////////////
// WEBPACK FOOTER
// ./~/@uniiverse/library/components/footer/translations/sv.json
// module id = 1602
// module chunks = 0 1 2 4 5 6 7 8 9 10 11 12 13 14 15 16